<script lang="ts">
    import { Component } from 'vue-facing-decorator';
    import Vue from "vue";
    import { isNullOrWhitespace } from "@common/Common";

    export class MemberReadModel {
        WorkspaceUserId: number;
        Email: string;
        Name: string;
    }

    @Component({
        props: {
            SurveyId: Number,
            Name: String,
            Description: String,
            Members: Array,
            OwnerEmail: String,
            NameError: String,
            ResponseDueDate: String
        }        
    })
    export default class EstimationsPanelEditor extends Vue
    {
        get surveyId(): number { return this.$props.SurveyId; }
        get nameError(): string { return this.$props.NameError; }   

        get title(): string { return this.surveyId > 0 ? `Edit panel: ${this.$props.Name}` : "Create opinion panel"; }

        get createVisible(): boolean { return this.surveyId === 0; }
        get updateVisible(): boolean { return this.surveyId !== 0; }
        get deleteVisible(): boolean { return this.surveyId !== 0; }

        name: string = null;
        description: string = null;
        members: MemberReadModel[] = null;
        owner: MemberReadModel = null;
        responseDueDate: string | null = null;

        mounted()
        {
            this.name = this.$props.Name;
            this.description = this.$props.Description;
            this.members = this.$props.Members;
            this.responseDueDate = this.$props.ResponseDueDate;

            const ownerEmail = this.$props.OwnerEmail;

            let owner: MemberReadModel = null;

            if (!isNullOrWhitespace(ownerEmail))
            {
                owner = this.members.find(a => a.Email === ownerEmail);

                if (owner == null)
                {
                    owner = new MemberReadModel();
                    owner.Name = ownerEmail;
                    owner.Email = ownerEmail;

                    this.members.push(owner);
                }

                this.owner = owner;
            }
        }

        deletePanel()
        {
            this.$emit('deletePanel', this.surveyId);
        }

        createPanel()
        {
            this.$emit('createPanel', {
                Name: this.name,
                Description: this.description,
                OwnerEmail: this.owner?.Email,
                ResponseDueDate: this.responseDueDate,
            });
        }

        updatePanel()
        {
            this.$emit('updatePanel', {
                SurveyId: this.surveyId,
                Name: this.name,
                Description: this.description,
                OwnerEmail: this.owner?.Email,
                ResponseDueDate: this.responseDueDate,
            });
        }

        close()
        {
            this.$emit('close');
        }
    }

</script>

<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{title}}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div class="form-group">
                            <label>Name</label>
                            <input v-model.trim="name" type="text" class="form-control">
                            <div class="error">{{nameError}}</div>
                        </div>

                        <div class="form-group">
                            <label>Description</label>
                            <textarea v-model.trim="description" type="text" class="form-control"></textarea>
                        </div>

                        <div class="form-group">
                            <label>Owner</label>
                            <select v-model="owner" class="form-control">
                                <option :value="null">None</option>
                                <option v-for="m in members" :value="m" :key="m.Email">{{m.Name}}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Response due date:</label>
                            <input type="date" class="form-control" v-model="responseDueDate" />
                        </div>
                    </div>

                    <div class="modal-footer justify-content-between">

                        <div class="dropdown dropup">
                            <button v-if="deleteVisible" type="button" class="btn btn-danger" data-toggle="dropdown">Delete</button>
                            <div class="dropdown-menu" role="menu" style="padding: 10px;">
                                <a class="dropdown-item">Cancel</a>
                                <a class="dropdown-item" @click="deletePanel">Confirm</a>
                            </div>
                        </div>

                        <div>
                            <button v-if="createVisible" @click="createPanel" type="button" class="btn btn-primary">Create</button>
                            <button v-if="updateVisible" @click="updatePanel" type="button" class="btn btn-primary">Save</button>
                            <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>      


<style scoped>
</style>